import AccountSettings from "@/components/shared/settings/sections/AccountSettings";
import { useBreadcrumb } from "@/contexts/shared/breadcrumb";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { useMountEffect } from "@react-hookz/web";

const AdminAccountSettings = () => {
    const { setBreadcrumbs } = useBreadcrumb();

    useDocumentTitle("Account Settings");

    useMountEffect(() => {
        setBreadcrumbs([
            { label: "Admin", path: "/admin/home" },
            { label: "Settings" },
            { label: "Account" },
        ]);
    });
    return <AccountSettings />;
};

export default AdminAccountSettings;
